import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EndPointService {
  forgotPassword: string = environment.server + '/api/auth/forgotPassword';
  login: string = environment.server + '/api/auth/signIn';
  resetPassword: string = environment.server + '/api/auth/resetPassword';
  register: string = environment.server + '/api/users/signup';
  activateAccount: string = environment.server + '/api/auth/activateAccount';
  getMyProfile: string = environment.server + '/api/profile';
  deleteMyAccount: string = environment.server + '/api/profile/delete-my-account';
  resendOtp: string = environment.server + '/api/auth/resend-activation-link/';
  emotionReport: string = environment.server + '/api/emotion-reports';
  feedback: string = environment.server + '/api/feedback';
  // CHANGE_PASSWORD_V1: string = environment.server + '/api/auth/changePassword';

  project: string = environment.server + '/api/project';

}
